import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, change, formValueSelector } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { onSubmit } from '../../../../../common/components/submit-button';
import OptionSelect from '../../../../../common/components/render-input/option-select';

export const formName = Routes.STEPONE;

const validate = values => v(values, {
    loanType: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        }
    }
});

const loanTypeOptions = {
    'Personal': {
        title: 'Personal Loan',
        content: 'Content describing a personal loan.',
        frequency: 52
    },
    'Business': {
        title: 'Business Loan',
        content: 'Content describing a business loan.',
        frequency: 52
    },
    'Agriculture': {
        title: 'Agriculture Loan',
        content: 'Content describing a agriculture loan.',
        frequency: 26
    }
};

const defaultLoanTypeIndex = 0; // Personal

class StepOneForm extends Component {
    componentDidUpdate(){
        const {
            props: {
                changeFieldValue,
                selectedFrequency
            }
        } = this;
        changeFieldValue('loanTypeNum', loanTypeOptions[selectedFrequency].frequency);
    }

    render() {
        return (
            <form className={styles.form}>
                <Field
                    name='loanType'
                    label='Loan Type'
                    options={loanTypeOptions}
                    component={OptionSelect}
                />
            </form>
        );
    }
}

const selector = formValueSelector(formName);

const mapStateToProps = (state) => ({
    selectedFrequency: Object.keys(loanTypeOptions).find(key => key === selector(state, 'loanType'))
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

StepOneForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: {
        loanType: Object.keys(loanTypeOptions)[defaultLoanTypeIndex],
        loanTypeNum: Object.values(loanTypeOptions)[defaultLoanTypeIndex].frequency
    },
    redirectPath: `/loan${Routes.STEPTWO}`
})(StepOneForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepOneForm));

